module.exports = __webpack_public_path__ + "static/media/S2N13-3.204c4c6a.svg";